import { HeaderActionButton } from "frontend/app-header/header-action-button/header-action-button";
import styles from "./right-header.module.css";
import { VideoCallHangupIcon, VideoCallIcon } from "frontend/app-header/right-header/icons";
import { memo, useRef } from "react";
import { useHeaderContext } from "frontend/context/header-context";
import { useAtomValue } from "jotai";
import { syncServiceAtom } from "state-atoms";
import { useCollaboratorsInVideoChat } from "subscriptions";
import { useHover } from "frontend/ui-components/floaters/use-hover";
import { Tooltip } from "frontend/ui-components/floaters/tooltip";

export const VideoCallTrigger = memo(() => {
  const { onClickVideoCall, onClickVideoCallHangUp } = useHeaderContext();
  const syncService = useAtomValue(syncServiceAtom);
  const videoChat = useCollaboratorsInVideoChat(syncService?.getReplicache());
  const numberOfOthers = videoChat.others?.length ?? 0;
  const ongoingChat = numberOfOthers > 0 || !!videoChat.myVideoPresence;
  const numberOfPeopleInCall = numberOfOthers + (videoChat.myVideoPresence ? 1 : 0);
  const iconRef = useRef<HTMLDivElement>(null);
  const iconHover = useHover(iconRef);

  return (
    <>
      <HeaderActionButton
        data-testid="video-call-icon"
        className={styles.actionIcon}
        onClick={onClickVideoCall}
        ref={iconRef}
      >
        <VideoCallIcon active={ongoingChat} numberOfParticipants={numberOfPeopleInCall} />
        {iconHover && (
          <Tooltip
            design="monday"
            label={"Video chat"}
            relativeTo={iconRef}
            side={"bottom"}
            customStyle={{ borderRadius: 3 }}
          />
        )}
      </HeaderActionButton>
      {ongoingChat && (
        <HeaderActionButton className={styles.actionIcon} onClick={onClickVideoCallHangUp}>
          <VideoCallHangupIcon color="#ff6a5f" />
        </HeaderActionButton>
      )}
    </>
  );
});
VideoCallTrigger.displayName = "VideoCallTrigger";
